import { useCallback, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function useCampSignups() {
  const [camps, setCamps] = useState([]);
  const [members, setMembers] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const [signups, setSignups] = useState([]);

  const load = useCallback(async () => {
    const [c, m] = await Promise.all([api.get("/camps"), api.get("/members")]);
    setCamps(c.data);
    setMembers(m.data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const youthMembers = useMemo(() => members.filter((m) => m.section !== "leaders"), [members]);

  const loadSignups = useCallback(async (campId) => {
    const { data } = await api.get(`/camps/${campId}/signups`);
    setSignups(data);
  }, []);

  const toggleExpand = (campId) => {
    if (expanded === campId) { setExpanded(null); return; }
    setExpanded(campId);
    loadSignups(campId);
  };

  const refresh = async (campId) => { await Promise.all([loadSignups(campId), load()]); };
  const signedUp = (memberId) => signups.find((s) => s.member_id === memberId);

  const toggleSignup = async (campId, memberId) => {
    if (signedUp(memberId)) await api.delete(`/camps/${campId}/signups/${memberId}`);
    else await api.post(`/camps/${campId}/signups`, { member_id: memberId, paid: false });
    refresh(campId);
  };

  const togglePaid = async (campId, memberId) => {
    const s = signedUp(memberId);
    if (!s) return;
    await api.post(`/camps/${campId}/signups`, { member_id: memberId, paid: !s.paid });
    toast.success(s.paid ? "Marked as unpaid" : "Marked as paid — ledger updated");
    refresh(campId);
  };

  const deleteCamp = async (id) => {
    const { data } = await api.delete(`/camps/${id}`);
    if (data.deleted && expanded === id) setExpanded(null);
    load();
    return data;
  };

  return { camps, youthMembers, expanded, signups, load, toggleExpand, toggleSignup, togglePaid, deleteCamp };
}
